module.exports = __webpack_public_path__ + "img/client-download-icon-cache-tool.84b38d50.png";